// extracted by mini-css-extract-plugin
export default {"header":"LssvmDbo","titleWrap":"RY5H_6ze","title":"KrEeNeGb","subtitle":"q_Ul5lbp","closeButton":"MhLhwfyp","closeIcon":"hMAMLLha"};